// Upsells to someone who already pays: the Basic -> Creator sheet
// (components/upsell/CreatorUpsellSheet) and the Pro Coin packs
// (components/modals/CreditPackModal).
// See messages/README.md for how to add strings.
//
// Prices arrive already formatted as {price}; {files} is a count and
// {duration} is "2 min 5 s" (units left as they are, they read the same in
// es/pt). Pack prices in CreditPackModal are fixed USD strings, not here.
export const upsell = {
  en: {
    // Creator sheet, per reason: headline, lead, ticks, button.
    "upsell.creator.train.title": "Start training with Creator",
    "upsell.creator.train.lead": "Training a voice comes with Creator.",
    "upsell.creator.train.tick1": "Train unlimited voices",
    "upsell.creator.train.tick2": "Marble Run videos, 50 coins a month",
    "upsell.creator.train.tick3": "Everything in your plan stays",
    "upsell.creator.train.cta": "Upgrade and start training",

    "upsell.creator.export.title": "Export in 1080p",
    "upsell.creator.export.lead": "Creator exports your videos in full 1080p.",
    "upsell.creator.export.tick1": "1080p exports",
    "upsell.creator.export.tick2": "Marble Run videos, 50 coins a month",
    "upsell.creator.export.tick3": "Train unlimited voices",
    "upsell.creator.export.cta": "Upgrade and export in 1080p",

    "upsell.creator.marble.title": "Marble Run is on Creator",
    "upsell.creator.marble.lead":
      "Turn covers into Marble Run videos, ready for TikTok and Reels.",
    "upsell.creator.marble.tick1": "50 Marble Run coins every month",
    "upsell.creator.marble.tick2": "1080p studio exports",
    "upsell.creator.marble.tick3": "Train unlimited voices",
    "upsell.creator.marble.cta": "Upgrade and make a Marble Run",

    "upsell.creator.video.title": "Videos are on Creator",
    "upsell.creator.video.lead":
      "Turn your covers into shareable videos for TikTok and Reels.",
    "upsell.creator.video.tick1": "Shareable videos, 50 coins a month",
    "upsell.creator.video.tick2": "1080p studio exports",
    "upsell.creator.video.tick3": "Train unlimited voices",
    "upsell.creator.video.cta": "Upgrade and make my video",

    // Creator sheet, shared.
    "upsell.creator.samplesOne":
      "Your vocals are ready: {files} file, {duration}. ",
    "upsell.creator.samplesMany":
      "Your vocals are ready: {files} files, {duration}. ",
    "upsell.creator.nothing": "Nothing",
    "upsell.creator.today": "today",
    "upsell.creator.toPayToday": "to pay today",
    "upsell.creator.thenMonth": "then {price} a month",
    "upsell.creator.credited":
      "The rest of your current month is credited. Cancel any time.",
    "upsell.creator.priceError":
      "We couldn't load your upgrade price. You can upgrade any time from Settings.",
    "upsell.creator.upgrading": "Upgrading...",
    "upsell.creator.notNow": "Not now",
    "upsell.creator.payFailed":
      "The payment didn't go through, so nothing changed. Check your card in Settings and try again.",

    // Pro Coin packs.
    "upsell.coins.title": "Get Pro Coins",
    "upsell.coins.subtitle": "Each coin creates one shareable video",
    "upsell.coins.coinAlt": "Pro Coin",
    "upsell.coins.useMarble": "Marble Run Videos",
    "upsell.coins.useLyric": "Lyric Videos",
    "upsell.coins.useTemplates": "All Video Templates",
    "upsell.coins.bestValue": "BEST VALUE",
    "upsell.coins.mostCoins": "MOST COINS",
    "upsell.coins.proCoins": "pro coins",
    "upsell.coins.each": "{price}/each",
    "upsell.coins.purchase": "Purchase",
    "upsell.coins.footer":
      "Pro Coins are added instantly and never expire. 1 coin = 1 video.",
  },
  es: {
    "upsell.creator.train.title": "Empieza a entrenar con Creator",
    "upsell.creator.train.lead": "Entrenar una voz viene con Creator.",
    "upsell.creator.train.tick1": "Entrena voces ilimitadas",
    "upsell.creator.train.tick2": "Videos Marble Run, 50 monedas al mes",
    "upsell.creator.train.tick3": "Conservas todo lo de tu plan",
    "upsell.creator.train.cta": "Mejorar y empezar a entrenar",

    "upsell.creator.export.title": "Exporta en 1080p",
    "upsell.creator.export.lead": "Creator exporta tus videos en 1080p.",
    "upsell.creator.export.tick1": "Exportaciones en 1080p",
    "upsell.creator.export.tick2": "Videos Marble Run, 50 monedas al mes",
    "upsell.creator.export.tick3": "Entrena voces ilimitadas",
    "upsell.creator.export.cta": "Mejorar y exportar en 1080p",

    "upsell.creator.marble.title": "Marble Run está en Creator",
    "upsell.creator.marble.lead":
      "Convierte tus covers en videos Marble Run, listos para TikTok y Reels.",
    "upsell.creator.marble.tick1": "50 monedas de Marble Run cada mes",
    "upsell.creator.marble.tick2": "Exportaciones del estudio en 1080p",
    "upsell.creator.marble.tick3": "Entrena voces ilimitadas",
    "upsell.creator.marble.cta": "Mejorar y hacer un Marble Run",

    "upsell.creator.video.title": "Los videos están en Creator",
    "upsell.creator.video.lead":
      "Convierte tus covers en videos para compartir en TikTok y Reels.",
    "upsell.creator.video.tick1": "Videos para compartir, 50 monedas al mes",
    "upsell.creator.video.tick2": "Exportaciones del estudio en 1080p",
    "upsell.creator.video.tick3": "Entrena voces ilimitadas",
    "upsell.creator.video.cta": "Mejorar y hacer mi video",

    "upsell.creator.samplesOne":
      "Tus pistas de voz están listas: {files} archivo, {duration}. ",
    "upsell.creator.samplesMany":
      "Tus pistas de voz están listas: {files} archivos, {duration}. ",
    "upsell.creator.nothing": "Nada",
    "upsell.creator.today": "hoy",
    "upsell.creator.toPayToday": "que pagar hoy",
    "upsell.creator.thenMonth": "luego {price} al mes",
    "upsell.creator.credited":
      "Se te acredita lo que queda de tu mes actual. Cancela cuando quieras.",
    "upsell.creator.priceError":
      "No pudimos cargar el precio de la mejora. Puedes mejorar tu plan cuando quieras desde Configuración.",
    "upsell.creator.upgrading": "Mejorando...",
    "upsell.creator.notNow": "Ahora no",
    "upsell.creator.payFailed":
      "El pago no se completó, así que no cambió nada. Revisa tu tarjeta en Configuración e inténtalo de nuevo.",

    "upsell.coins.title": "Consigue monedas Pro",
    "upsell.coins.subtitle": "Cada moneda crea un video para compartir",
    "upsell.coins.coinAlt": "Moneda Pro",
    "upsell.coins.useMarble": "Videos Marble Run",
    "upsell.coins.useLyric": "Videos con letra",
    "upsell.coins.useTemplates": "Todas las plantillas de video",
    "upsell.coins.bestValue": "MEJOR PRECIO",
    "upsell.coins.mostCoins": "MÁS MONEDAS",
    "upsell.coins.proCoins": "monedas Pro",
    "upsell.coins.each": "{price} c/u",
    "upsell.coins.purchase": "Comprar",
    "upsell.coins.footer":
      "Las monedas Pro se añaden al instante y no vencen. 1 moneda = 1 video.",
  },
  pt: {
    "upsell.creator.train.title": "Comece a treinar com o Creator",
    "upsell.creator.train.lead": "Treinar uma voz vem com o Creator.",
    "upsell.creator.train.tick1": "Treine vozes ilimitadas",
    "upsell.creator.train.tick2": "Vídeos Marble Run, 50 moedas por mês",
    "upsell.creator.train.tick3": "Tudo do seu plano continua",
    "upsell.creator.train.cta": "Fazer upgrade e começar a treinar",

    "upsell.creator.export.title": "Exporte em 1080p",
    "upsell.creator.export.lead": "O Creator exporta seus vídeos em 1080p.",
    "upsell.creator.export.tick1": "Exportações em 1080p",
    "upsell.creator.export.tick2": "Vídeos Marble Run, 50 moedas por mês",
    "upsell.creator.export.tick3": "Treine vozes ilimitadas",
    "upsell.creator.export.cta": "Fazer upgrade e exportar em 1080p",

    "upsell.creator.marble.title": "O Marble Run está no Creator",
    "upsell.creator.marble.lead":
      "Transforme seus covers em vídeos Marble Run, prontos para TikTok e Reels.",
    "upsell.creator.marble.tick1": "50 moedas de Marble Run todo mês",
    "upsell.creator.marble.tick2": "Exportações do estúdio em 1080p",
    "upsell.creator.marble.tick3": "Treine vozes ilimitadas",
    "upsell.creator.marble.cta": "Fazer upgrade e criar um Marble Run",

    "upsell.creator.video.title": "Os vídeos estão no Creator",
    "upsell.creator.video.lead":
      "Transforme seus covers em vídeos para compartilhar no TikTok e no Reels.",
    "upsell.creator.video.tick1": "Vídeos para compartilhar, 50 moedas por mês",
    "upsell.creator.video.tick2": "Exportações do estúdio em 1080p",
    "upsell.creator.video.tick3": "Treine vozes ilimitadas",
    "upsell.creator.video.cta": "Fazer upgrade e criar meu vídeo",

    "upsell.creator.samplesOne":
      "Seus vocais estão prontos: {files} arquivo, {duration}. ",
    "upsell.creator.samplesMany":
      "Seus vocais estão prontos: {files} arquivos, {duration}. ",
    "upsell.creator.nothing": "Nada",
    "upsell.creator.today": "hoje",
    "upsell.creator.toPayToday": "a pagar hoje",
    "upsell.creator.thenMonth": "depois {price} por mês",
    "upsell.creator.credited":
      "O restante do seu mês atual vira crédito. Cancele quando quiser.",
    "upsell.creator.priceError":
      "Não conseguimos carregar o preço do upgrade. Você pode fazer o upgrade quando quiser em Configurações.",
    "upsell.creator.upgrading": "Fazendo upgrade...",
    "upsell.creator.notNow": "Agora não",
    "upsell.creator.payFailed":
      "O pagamento não foi concluído, então nada mudou. Confira seu cartão em Configurações e tente novamente.",

    "upsell.coins.title": "Compre moedas Pro",
    "upsell.coins.subtitle": "Cada moeda cria um vídeo para compartilhar",
    "upsell.coins.coinAlt": "Moeda Pro",
    "upsell.coins.useMarble": "Vídeos Marble Run",
    "upsell.coins.useLyric": "Vídeos com letra",
    "upsell.coins.useTemplates": "Todos os modelos de vídeo",
    "upsell.coins.bestValue": "MAIS VANTAJOSO",
    "upsell.coins.mostCoins": "MAIS MOEDAS",
    "upsell.coins.proCoins": "moedas Pro",
    "upsell.coins.each": "{price} cada",
    "upsell.coins.purchase": "Comprar",
    "upsell.coins.footer":
      "As moedas Pro são adicionadas na hora e não expiram. 1 moeda = 1 vídeo.",
  },
};
